import { React, useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { formatDate, formatDNI } from "./format";

const Resultados = (props) => {

  const location = useLocation();
  var { searchdata } = location.state || {};
  console.log('Datos en resultados:', searchdata);


  const usenav = useNavigate();
  /*    var resu1 = "";
  
        if(search !== null)
        {
            resu1 = search ;
  
        } */
  /// const [listSearch, setListSearch] = useState([] );

  /*
useEffect(() => {
  

}, []);

*/


  const [verActivos, setVerActivos] = useState(true);


  const handleActivos = () => {
    //  event.preventDefault()
    setVerActivos(!verActivos);

  };

  function handleGoLiq(alumno, ev) {
    console.log("pasa");
    ev.preventDefault()

    usenav('/verliquid', { state: { unalumno: alumno } })

  }

  function handleGoAlumno(id, event) {
    console.log("handle Alumno", id, "--", event.target);


    var jstring;
    var url;

    jstring = '{"id" : "' + id + '" }';
    url = `${process.env.REACT_APP_API_URL}/alu/getone`;

    /* fetch de búsqueda */
    var options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      mode: 'cors',
      credential: 'include',
      body: jstring,
      //JSON.stringify({"code" : 4, "activo" : true}),

    };

    fetch(url, options)
      .then(response => response.json())
      .then(data => {
        console.log("búsqueda", data.data);
        //usenav('/resultados', { state: { searchdata: data.data } } );
        usenav('/alumnos', { state: { unalumno: data.data } });
        /*  if ( data.lista.length)
          {

            
            setListSearch(data.lista);

          }          
            */
      })





    //  usenav('/alumnos');
  }
  if (props.vtoken) {
    return (
      <>
        <div>
          <div className="container-fluid">

            <div className="row  border-primary">



              <div className="col  col-2 text-center border-info">
                <div className="checkbox">
                  <label>
                    <input type="checkbox" onChange={handleActivos} value="" checked={verActivos} />
                    &nbsp; {"Ver solo activos"} </label>
                </div>
              </div>

            </div>



            <div className="row m-3">

              <table className="table table-striped table-primary table-hover m-3 p-2">
                <thead>
                  <tr className="row" >
                    <th className="col-1" >Título</th>
                    <th className="col-1" >Sección</th>
                    <th className="col-2" >Apellido</th>
                    <th className="col-2" >Nombre</th>
                    <th className="col-1" >DNI</th>
                    <th className="col-1" >Fec. Nacim.</th>
                    <th className="col-1" >Fec. Ingreso</th>
                    <th className="col-1" >Curso</th>
                    <th className="col-1" >División</th>
                    <th className="col-1" >Liquidación</th>


                  </tr>
                </thead>
                <tbody>
                  {

                    searchdata.filter(item => !verActivos || (verActivos && (item.Alu_Habilitado != 0))).map((unolista, index) => (

                      <tr key={index + '_row'} className="row fila-click">

                        <td key={index + '_ident'} className="col-1" onClick={(event) => handleGoAlumno(unolista.Alu_IdAlu, event)}>
                          {'Alumnos'}
                        </td>
                        <td key={index + '_seccion'} className="col-1" onClick={(event) => handleGoAlumno(unolista.Alu_IdAlu, event)}>
                          {unolista.Sec_Nombre}
                        </td>
                        <td key={index + '_ape'} className="col-2" onClick={(event) => handleGoAlumno(unolista.Alu_IdAlu, event)}>
                          {unolista.Alu_Apellido}
                        </td>
                        <td key={index + '_nom'} className="col-2" onClick={(event) => handleGoAlumno(unolista.Alu_IdAlu, event)}>
                          {unolista.Alu_Nombre}
                        </td>
                        <td key={index + '_dni'} className="col-1" onClick={(event) => handleGoAlumno(unolista.Alu_IdAlu, event)}>
                          {formatDNI(unolista.Alu_DNI)}
                        </td>
                        <td key={index + '_fnac'} className="col-1" onClick={(event) => handleGoAlumno(unolista.Alu_IdAlu, event)}>
                          {formatDate(unolista.Alu_FNac)}
                        </td>
                        <td key={index + '_fing'} className="col-1" onClick={(event) => handleGoAlumno(unolista.Alu_IdAlu, event)}>
                          {formatDate(unolista.Alu_FIng)}
                        </td>
                        <td key={index + '_curso'} className="col-1" onClick={(event) => handleGoAlumno(unolista.Alu_IdAlu, event)}>
                          {unolista.Cur_Nombre}
                        </td>
                        <td key={index + '_divis'} className="col-1" onClick={(event) => handleGoAlumno(unolista.Alu_IdAlu, event)}>
                          {unolista.Div_Nombre}
                        </td>
                        <td key={index + '_irliq'} className="col-1" >

                          <button type="button" className="filtrar" onClick={(event) => handleGoLiq(unolista.Alu_IdAlu, event)} >Ver</button>
                        </td>



                      </tr>
                    )
                    )

                  }
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </>
    )
  }
  else {

    return (
      <> </>
    )
  }

}

export default Resultados;